import React from 'react';
import './Spinner.css';
import logoLoading from '../../Res/logo-loading.gif';
import { ProgressIndicator } from '../ProgressIndicator';

const Spinner = ({ text, time, customText }) => (

  <div className="loading-spinner-wrapper">
    <ProgressIndicator />
    {
      customText ? (
        <div className="glass-generator">
          <p className="spinner-label">{customText?.split('\n')[0]}<br />{customText?.split('\n')[1]}</p>
        </div>
      ) : null}
  </div>
);

export default Spinner;
